// extracted by mini-css-extract-plugin
export default {"style__button":"Button_style__button__0A3TY","text__style":"Button_text__style__Mpw71"};